export default function formatCep(num) {
  return num?.length === 8
    ? `${num.substring(0, 5)}-${num.substring(5)}`
    : num?.length === 7
      ? `${num.padStart(8, "0").substring(0, 5)}-${num.padStart(8, "0").substring(5)}`
      : num
}
